import { type FC } from 'react';
import { SamplePlanTableProvider } from '@/components/Samples/SamplePlanTable/SamplePlanTableProvider';
import { type TeamGlossary } from '@/model/Glosary.model';
import { SamplePlanTable } from '@/components/Samples/SamplePlanTable/SamplePlanTable';
import { type CreateStudyState } from '@/components/Studies/Create/Create.model';
import { useApiHook } from '@/support/Hooks/api/useApiHook';
import {
  useSamplePlanAnimalData,
  useSamplePlanGroupData,
} from '@/components/Studies/Create/Steps/SamplingPlan/SamplePlan.utils';
import { _isEmpty } from '@/littledash';

export const SamplingPlanSummary: FC<{ state: CreateStudyState }> = ({ state }) => {
  const { response: sampleMetadataGlossaryResponse } = useApiHook({
    endpoint: 'GET /api/v1/metadata-glossary',
    query: {
      include_inactive: false,
      filter_type: 'sample_meta',
    },
    invokeOnInit: true,
    options: { onError: { slug: 'sample-meta-load' } },
  });
  const { response: sampleGlossaryResponse } = useApiHook({
    endpoint: 'GET /api/v1/team-glossary',
    query: {
      group: 'samples',
      perPage: -1,
      order: 'asc',
      sort: 'title',
    },
    options: { onError: { slug: 'samples-glossary-load' } },
  });
  const groupData = useSamplePlanGroupData();
  const animals = useSamplePlanAnimalData();
  if (_isEmpty(state?.study?.sample_definitions)) {
    return (
      <div className="lh-copy bb b--moon-gray">
        <div>
          <div className="pa4 f6 tc bg-near-white near-black">No planned samples have been added</div>
        </div>
      </div>
    );
  }
  return (
    <div>
      <SamplePlanTableProvider
        sample_definitions={state.study.sample_definitions ?? []}
        groups={groupData.groupTargets}
        registered_animals={animals.registered_animals}
        planned_animals={animals.planned_animals}
        metadata_glossary={sampleMetadataGlossaryResponse?.body ?? []}
        sample_glossary={(sampleGlossaryResponse?.body as { data?: Array<TeamGlossary> })?.data ?? []}
      >
        <SamplePlanTable />
      </SamplePlanTableProvider>
    </div>
  );
};
